/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { USState } from './USState';

export type ClassDefinitionItemDto = {
  /**
   * Unique class name
   */
  className: string;
  /**
   * State code
   */
  state?: USState;
  /**
   * Rating area
   */
  ratingArea?: string;
  /**
   * Employment type
   */
  employmentType?: ClassDefinitionItemDto.employmentType;
  /**
   * Wage type
   */
  wageType?: ClassDefinitionItemDto.wageType;
  /**
   * Custom class category
   */
  customClassCategory?: string;
};
export namespace ClassDefinitionItemDto {
  /**
   * Employment type
   */
  export enum employmentType {
    FULL_TIME = 'FULL_TIME',
    PART_TIME = 'PART_TIME',
  }
  /**
   * Wage type
   */
  export enum wageType {
    SALARY = 'SALARY',
    HOURLY = 'HOURLY',
  }
}
